import { StyleSheet } from 'react-native'

import { colors } from '../../design-system/theme/partners/tokens'

export const linkStyles = StyleSheet.create({
  link: {
    color: colors.primary['500'],
    textDecorationLine: 'underline',
  },
})
